import { Skeleton } from '@components/ui/skeleton';

type Props = {
  length?: number;
};

export function StatusTimelineLoading({ length = 4 }: Props) {
  return (
    <div className="relative flex justify-between gap-x-6">
      {Array.from({ length }).map((_, index) => (
        <div key={`step-loading-${index}`}>
          <Skeleton className="bg-card mx-auto mb-2 flex size-13 items-center justify-center rounded-full p-2" />
          <Skeleton className="bg-card h-6 w-37 justify-center" />
        </div>
      ))}
      <Skeleton className="bg-card absolute top-6 right-0 left-6.5 z-0 mx-12 h-1.5 border-0" />
    </div>
  );
}
